import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = ['La falta de claridad', 'El miedo a mostrarse', 'La inseguridad', 'El caos mental', 'No tener una estrategia alineada contigo'];
  return <section className="py-24 bg-brand-brown-light px-6" data-id="element-123">
      <div className="max-w-6xl mx-auto text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-125">
          <p className="text-xl md:text-2xl font-serif text-brand-cream leading-relaxed mb-8" data-id="element-126">
            Si quieres empezar en el mundo digital… o ya comenzaste pero sigues
            creando sin dirección, sin ventas y sintiéndote perdida,
          </p>
          <p className="text-4xl md:text-5xl lg:text-6xl font-script text-brand-gold mb-12 leading-tight" data-id="element-127">
            esta mentoría es para ti.
          </p>

          <div className="w-16 h-px bg-brand-gold/50 mx-auto mb-12" data-id="element-128"></div>

          <p className="text-lg text-brand-cream/70 mb-8 font-light" data-id="element-129">
            Porque muchas veces el problema no es el producto. Ni siquiera
            Instagram.
            <br data-id="element-130" />
            <span className="font-medium text-brand-cream mt-4 block" data-id="element-131">
              El verdadero problema es:
            </span>
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3" data-id="element-132">
            {problems.map((problem, index) => <Fragment key={index} data-id="element-133">
                {index > 0 && <span className="text-brand-gold/60 text-2xl select-none" aria-hidden="true" data-id="element-134">
                    ✦
                  </span>}
                <motion.span initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="text-xl md:text-2xl lg:text-3xl font-serif text-brand-cream/90 italic whitespace-nowrap" data-id="element-135">
                  {problem}
                </motion.span>
              </Fragment>)}
          </div>
        </motion.div>
      </div>
    </section>;
}